import React from 'react'
import ScrollToTop from "react-scroll-to-top";
import { Link } from "react-router-dom";
import Header from '../inc/Header';

function StayBook() {
  return (
    <div>
          <Header/>
        <br/>
        <br/>
        <br/>
        <br/>
               <ScrollToTop smooth top="100" color="maroon" />
        <div className="petprescriptionupload">
                <div className="album py-1">

                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Stay For Book</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>

                  <div className="album py-2">

                    <div className="container">
                        <h3 style={{color:"darkBlue"}}><b>Stay For Book</b></h3>
                        <h6>Update Soon !</h6>
                        </div>
                    </div>
                    <br/>
                    <br/>
    </div>
  )
}

export default StayBook